import { useState } from 'react';

export type appearance = 'info' | 'success' | 'error' | 'warning';

export const useAlertMessage = () => {
  const [requestStatusMessage, setRequestStatusMessage] = useState('');
  const [requestStatusAppearance, setRequestStatusAppearance] =
    useState<appearance>();

  const showAlert = (message: string, appearance: appearance) => {
    setRequestStatusMessage(message);
    setRequestStatusAppearance(appearance);
    setTimeout(() => {
      setRequestStatusMessage('');
      setRequestStatusAppearance(null);
    }, 3000);
  };

  const hideAlert = () => {
    setRequestStatusMessage('');
    setRequestStatusAppearance(null);
  };

  return {
    requestStatusMessage,
    requestStatusAppearance,
    showAlert,
    hideAlert,
  };
};
